// Module
var code = `<template> <div class="dialog-permissions dialog-wrap"> <compose view-model="views/pages/admin/manage-organization/permissions" model.bind="model"></compose> </div> </template>`;
// Exports
module.exports = code;